export function mapFilterTypes () {
  return {
    select: {
      name: 'Equal',
      code: 'select',
      params: []
    },
    input: {
      name: 'Contains',
      code: 'code',
      params: []
    },
    boolean: {
      name: 'Exists',
      code: 'question',
      params: ['isnull']
    },
    dateRange: {
      name: 'In Date Range',
      code: 'daterange',
      params: ['after', 'before']
    },
    dayRange: {
      name: 'Relative Days From Today',
      code: 'dayrange',
      params: ['rel_min', 'rel_max']
    },
    numberRange: {
      name: 'In Days Range',
      code: 'numberrange',
      params: ['min', 'max']
    }
  }
}

export function filterElementsShipmentList () {
  return [
    {
      name: 'Carrier',
      code: 'carrier',
      types: ['select']
    },
    {
      name: 'Milestone',
      code: 'shipment_status',
      types: ['select']
    },
    {
      name: 'POL',
      code: 'pol_loc',
      types: ['input']
    },
    {
      name: 'POD',
      code: 'pod_loc',
      types: ['input']
    },
    {
      name: 'TSP',
      code: 'tsp_loc',
      types: ['input']
    },
    {
      name: 'POL Departure (ETD/ATD)',
      code: 'pol_departure',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'POD Arrival (ETA/ATA)',
      code: 'pod_arrival',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'ETD',
      code: 'etd',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'ETA',
      code: 'eta',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'ATD',
      code: 'atd',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'ATA',
      code: 'ata',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'DTA',
      code: 'dta',
      types: ['numberRange']
    },
    {
      name: 'DTD',
      code: 'dtd',
      types: ['numberRange']
    },
    {
      name: 'Created At',
      code: 'created_at',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'Last Update',
      code: 'last_update',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'Last Alert Walltime',
      code: 'last_alert_walltime',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'Days In POL',
      code: 'days_in_pol',
      types: ['numberRange']
    },
    {
      name: 'Days In POD',
      code: 'days_in_pod',
      types: ['numberRange']
    },
    {
      name: 'Days In TSP',
      code: 'days_in_tsp',
      types: ['numberRange']
    },
    {
      name: 'Transit Time',
      code: 'transit_time',
      types: ['numberRange', 'boolean']
    },
    {
      name: 'Storage Days At POL',
      code: 'storage_days_at_pol',
      types: ['numberRange']
    },
    {
      name: 'Storage Days At POD',
      code: 'storage_days_at_pod',
      types: ['numberRange']
    },
    {
      name: 'Days Between Empty Return And POD Departure',
      code: 'days_between_empty_return_and_pod_departure',
      types: ['numberRange']
    },
    {
      name: 'Days Between Empty Return And LIF Departure',
      code: 'days_between_empty_return_and_lif_departure',
      types: ['numberRange']
    },
    {
      name: 'Storage Free Days Gap',
      code: 'storage_free_days_gap',
      types: ['numberRange']
    },
    {
      name: 'Demurrage Free Days Gap',
      code: 'demurrage_free_days_gap',
      types: ['numberRange']
    },
    {
      name: 'Detention Free Days Gap',
      code: 'detention_free_days_gap',
      types: ['numberRange']
    },
    {
      name: 'Empty Return',
      code: 'empty_return',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'Empty Return Planned',
      code: 'empty_return_planned',
      types: ['dateRange', 'dayRange']
    }
  ]
}

export function filterConventionalShipmentList () {
  return [
    {
      name: 'POL',
      code: 'pol',
      types: ['input']
    },
    {
      name: 'POD',
      code: 'pod',
      types: ['input']
    },
    {
      name: 'ETD',
      code: 'etd',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'ETA',
      code: 'eta',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'ATD',
      code: 'atd',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'ATA',
      code: 'ata',
      types: ['dateRange', 'dayRange']
    },
    {
      name: 'Milestone',
      code: 'milestone',
      types: ['select']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/filters/FilterTypes.js